import { useCallback, useEffect, useState } from 'react';
import { fetchUsage, type UsagePayload } from '../../engines/ai/client';

/**
 * 用量与单价（服务端权威）。
 *
 * 未登录也要能拿到（界面需展示「今日剩余免费次数」）；
 * 登录用户额外带上账号中心余额，用于在发起前判断「是否够扣」。
 */
export interface UseUsageResult {
  usage: UsagePayload | null;
  loading: boolean;
  refresh: () => Promise<void>;
}

export function useUsage(): UseUsageResult {
  const [usage, setUsage] = useState<UsagePayload | null>(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const next = await fetchUsage();
      if (next) setUsage(next);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { usage, loading, refresh };
}
